import { company_name } from "@/i18n/variables";

const entities = {
	backups: {
		default: "Standard Backups",
		extra: "Extra Backups",
		title: "Backups",
	},
	cpu: {
		assigned: "Assigned",
		title: "CPU",
		usage: "In Use",
	},
	extra_storage: {
		bulk: {
			title: "Bulk Storage (HDD)",
		},
		default: {
			title: "Storage (SSD)",
		},
	},
	ip_config: {
		ipv4: "IPv4 Address",
		ipv6: "IPv6 Address",
		title: "IP Addresses",
	},
	login: {
		info: "The password below is the password set at the delivery of the VPS. Keep it safe, as it is only shown for <strong>31 days</strong> after delivery.",
		password: {
			expired: "Expired",
			expired_tooltip: `The VPS password set at delivery is only shown here for the first <strong>31 days</strong> after delivery, to prevent misinformation. If you have not saved your password, you can contact ${company_name}.`,
			title: "Password",
			tooltip:
				"This is the password set at the delivery of the VPS. Keep it safe, as it is only shown for <strong>31 days</strong> after delivery.",
		},
		title: "Login Details",
		username: "Username",
	},
	memory: {
		assigned: "Assigned",
		title: "Memory",
		usage: "In Use",
	},
	nameservers: {
		ns1_ipv4: "Nameserver 1 (IPv4)",
		ns1_ipv6: "Nameserver 1 (IPv6)",
		ns1_nat64: "Nameserver 1 (Nat64)",
		ns2_ipv4: "Nameserver 2 (IPv4)",
		ns2_ipv6: "Nameserver 2 (IPv6)",
		title: "Nameservers",
	},
	private_network: {
		title: "Private Network",
	},
	server_location: {
		title: "Server Location",
	},
	sla: {
		sla_level: {
			level_0: "Level 0",
			level_1: "Level 1",
			level_2: "Level 2",
			none: "No SLA",
		},
		title: "Service Level Agreement",
	},
	snapshots: {
		title: "Snapshots",
	},
	storage: {
		title: "Storage (SSD)",
	},
};

export default entities;
